import $ from 'jquery';

export function ColorPickerDirective($timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      color: '=',
      onchange: '&',
      ngModel: '=',
    },
    transclude: false,
    link: function (scope, element, attrs) {
      $timeout(function () {
        $(element).ColorPicker({
          flat: true,
          color: scope.color ? scope.color : '#ffffff',
          onChange: function (hsb, hex, rgb) {
            scope.onchange({ hsb: hsb, hex: hex, rgb: rgb });
          }
        });
      });

      scope.$watch('color', function (newValue, oldValue) {
        if (!scope.color)
          return;

        $(element).ColorPickerSetColor(scope.color);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./client/components/canvas/colorPicker.directive.js